module.exports = __webpack_public_path__ + "images/16292-INT4-c776ae2d5dee72540629520013db5733.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Carousel_1/16292-INT4.jpg
// module id = 34
// module chunks = 0